import React from 'react'
import AddCart from '../../components/CartComp/AddCart'

const CartPage = () => {
  return (
    <div>
        <AddCart />
    </div>
  )
}

export default CartPage